import storeFromArea from './storeFromArea';

/**
 * Zaregistruje se pro detekci změn v dané oblasti store.
 * Lze se zaregistrovat jak pro jednu, tak i pro více oblastí najednou.
 *
 * @param store - store
 * @param areas - oblast nebo pole oblastí, které chceme ve store sledovat
 * @param onChange - callback s parametry (newState, oldState, area), volaný při změně hodnot v oblastech store
 * @param initial - zda se má callback ihned vyvolat pro prvotní hodnoty ve store
 */
export default function subscribeToAreaChanges(store: any, areas: string | string[], onChange: <T>(newState: T, oldState: undefined | T, area: string) => void, initial: boolean = false) {
    if (!Array.isArray(areas)) {
        areas = [areas]; // Vstupem není pole ale jediná oblast
    }

    if (!areas.length) {
        return; // Optimalizace
    }

    const states = areas.map(area => storeFromArea(store.getState(), area));
    if (initial) {
        for (let i = 0; i < areas.length; i++) {
            onChange(states[i], undefined, areas[i]);
        }
    }

    store.subscribe(() => {
        const newStates = (areas as string[]).map(area => storeFromArea(store.getState(), area));

        for (let i = 0; i < areas.length; i++) {
            const state = states[i];
            const newState = newStates[i];

            if (state !== newState) {
                states[i] = newState;
                onChange(newState, state, areas[i]);
            }
        }
    });
}
